export const PAGE_TEXT = {
  landing: {
    title: 'CES Mail Merge',
    description: 'Welcome to the application.',
    loginButton: 'SIGN IN',
  },

  unauthorized: {
    title: 'Unauthorized Access',
    description:
      'You are not authorized to access this application.',
    backButton: 'GO BACK',
    logoutButton: 'LOG OUT & RETURN HOME',
    accessList: 'access list',
    unauthorizedAccess: 'unauthorized',
  },

  pageNotFound: {
    title: 'Page Not Found',
    description:
      `Oops! The page you are looking for doesn't exist, has been moved, or is temporarily unavailable.`,
    backButton: 'GO BACK',
    homeButton: 'GO TO HOME',
  },

  memberLogout: {
    title: 'You Have Been Logged Out',
    description:
      'You have successfully logged out of the application.',
    loginButton: 'SIGN IN',
  },

  errorBoundary: {
    titleLine1: 'Something',
    titleLine2: 'Went Wrong',
    description:
      'We are sorry, an unexpected error occurred on the current page. We are automatically tracking this issue. Please try refreshing or going back.',
    logoutButton: 'LOG OUT & RETURN HOME',
    refreshButton: 'REFRESH PAGE',
  },
} as const;